// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Lazyload{opacity:0;transition:all .3s ease-in-out}.Lazyload_loaded{opacity:1}\n", ""]);
// Exports
module.exports = exports;
